import React from "react";
import "./right-drawer.css";

const RightDrawer = ({
  open,
  onClose,
  title,
  children,
  width,
  placement,
  dir = "ltr",
  hideHeader = false,
  fullBleed,
  panelClassName = "",
}) => {
  const effectivePlacement = placement || (dir === "rtl" ? "left" : "right");
  const isFullBleed = fullBleed ?? hideHeader;

  return (
    <div
      className="oh-right-drawer"
      style={{
        pointerEvents: open ? "auto" : "none",
      }}
      aria-hidden={!open}
    >
      <div
        className={`oh-right-drawer__backdrop${open ? " is-open" : ""}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className={`oh-right-drawer__panel oh-right-drawer__panel--${effectivePlacement}${
          open ? " is-open" : ""
        }${panelClassName ? ` ${panelClassName}` : ""}`}
        style={{ width: width || "380px" }}
        dir={dir}
        role="dialog"
        aria-modal="true"
      >
        {!hideHeader && (
          <div className="oh-right-drawer__header">
            <div className="oh-right-drawer__title">{title}</div>
            <button
              type="button"
              className="oh-right-drawer__close"
              onClick={onClose}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        )}
        <div
          className={
            isFullBleed
              ? "oh-right-drawer__body oh-right-drawer__body--full"
              : "oh-right-drawer__body"
          }
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default RightDrawer;
